import { render, staticRenderFns } from "./ClientSupplier.vue?vue&type=template&id=f27369f8"
import script from "./ClientSupplier.vue?vue&type=script&lang=js"
export * from "./ClientSupplier.vue?vue&type=script&lang=js"
import style0 from "./ClientSupplier.vue?vue&type=style&index=0&id=f27369f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports